const STORAGE_KEY_NAME = 'checkout_abandon_basket_reminders';

const updateStorage = (reminderCheckboxes, detailsFormToken) => {
    const newStorageValue = {
        formToken: detailsFormToken,
        checkboxes: [...reminderCheckboxes].map(reminderCheckbox => (
            {
                id: reminderCheckbox.id,
                checked: reminderCheckbox.checked,
            }
        ))
    };

    localStorage.setItem(STORAGE_KEY_NAME, JSON.stringify(newStorageValue));
};

const updateCheckboxesState = (localStorageCheckboxesState) => {
    localStorageCheckboxesState.forEach((localStorageCheckboxState) => {
        const checkboxEl = document.getElementById(localStorageCheckboxState.id);
        checkboxEl.checked = localStorageCheckboxState.checked;
    });
};

const abandonBasketReminders = () => {
    const detailsForm = document.querySelector('[data-details-form]');
    const reminderCheckboxes = document.querySelectorAll('[data-reminder-id]');
    if (!detailsForm || reminderCheckboxes.length === 0) {
        return;
    }
    const detailsFormToken = detailsForm.querySelector('#form__token').value;
    const localStorageValue = localStorage.getItem(STORAGE_KEY_NAME);
    if (localStorageValue) {
        const localStorageValueJSON = JSON.parse(localStorageValue);
        if (localStorageValueJSON.formToken === detailsFormToken) {
            updateCheckboxesState(localStorageValueJSON.checkboxes);
        } else {
            localStorage.removeItem(STORAGE_KEY_NAME);
        }
    }
    reminderCheckboxes.forEach(reminderCheckbox =>
        reminderCheckbox.addEventListener('change', () =>
            updateStorage(reminderCheckboxes, detailsFormToken)
        )
    );
};

export default abandonBasketReminders;
